export default __webpack_public_path__ + "static/media/p2.5d4c4beb.jpeg";